<template>
    <div>
        <v-breadcrumbs :items="items" :class="breadcrumbClass"></v-breadcrumbs>
    </div>
</template>

<script>
import "@/assets/css/color.css"; // CSS needs to be imported for each dashboard

export default {
    props: {
        extraBreadcrumb: {
            type: Array,
            default: () => []
        },
        classType: {
            type: String,
            default: "style1" // Default class type
        }
    },
    data() {
        return {
            items: [],
            emp_roles: []
        };
    },
    computed: {
        breadcrumbClass() {
            return this.classType === "style1" ? "breadcrumb-style1" : "breadcrumb-style2";
        }
    },
    mounted() {
        this.generateBreadcrumbs();
    
    },
  
    methods: {
        // generateBreadcrumbs() {
        //     const rawLinks = sessionStorage.getItem("sblinks");
        //     const sblinks = rawLinks ? JSON.parse(rawLinks) : [];
        //     const currentPath = this.$route.path;
        //     const role = sessionStorage.getItem("para_role");
        //     const emp_roles = JSON.parse(sessionStorage.getItem("emp_role")) || {};

        //     const search_para_role = sessionStorage.getItem("search_para_role");
        //     const search_para_role_type = sessionStorage.getItem("search_para_role_type");
        //     const search_link = sessionStorage.getItem("search_link");

        //     // Start with Home
        //     this.items = [{ text: "Home", disabled: false, href: "/home" }];

        //     // Fix: Add search parameters ONLY IF sblinks is empty
        //     if (sblinks.length === 0) {
        //         if (search_para_role_type) {
        //             this.items.push({ text: search_para_role_type, disabled: true, href: "" });
        //         }
        //         if (search_para_role) {
        //             this.items.push({ text: search_para_role, disabled: true, href: "" });
        //         }

        //         if (search_link) {
        //             this.items.push({ text: search_link, disabled: true, href: "" });
        //         }
        //     }

        //     // Step 4: Check emp_roles
        //     if (Array.isArray(emp_roles.children) && emp_roles.children.length > 0) {
        //         this.items.push({
        //             text: emp_roles.name,
        //             disabled: false,
        //             href: "/emp-role-dashboard",
        //         });
        //     } else if (typeof emp_roles === "object" && emp_roles.para_role_type) {
        //         this.items.push({
        //             text: emp_roles.para_role_type,
        //             disabled: true,
        //             href: "",
        //         });
        //         if (emp_roles.para_role && !role) {
        //             this.items.push({
        //                 text: emp_roles.para_role,
        //                 disabled: true,
        //                 href: "",
        //             });

        //         }
        //     }

        //     // Step 3: Add Role Dashboard if role exists
        //     if (role) {
        //         this.items.push({ text: role, disabled: false, href: "/role-dashboard" });
        //     }

        //     // Step 5: Restore Last Breadcrumb (Avoid Duplicates)
        //     // let storedBreadcrumbs = JSON.parse(sessionStorage.getItem(`breadcrumbFlow_${role}`)) || [];
        //     // storedBreadcrumbs.forEach((breadcrumb) => {
        //     //     if (!this.items.some(item => item.text === breadcrumb.text)) {
        //     //         this.items.push(breadcrumb);
        //     //     }
        //     // });

        //     // Step 6: Find the Current Path in sblinks
        //     const matchingItem = sblinks.find(item => currentPath.endsWith(item.link));
        //     if (matchingItem) {
        //         const formattedLink = matchingItem.link.startsWith("/role-dashboard")
        //             ? matchingItem.link
        //             : `/role-dashboard${matchingItem.link}`;

        //         if (!this.items.some(item => item.href === formattedLink)) {
        //             this.items.push({
        //                 text: matchingItem.name,
        //                 disabled: false,
        //                 href: formattedLink
        //             });

        //             sessionStorage.setItem(`breadcrumbFlow_${role}`, JSON.stringify([{ text: matchingItem.name, href: formattedLink }]));
        //         }
        //     }

        //     // Step 7: Append extraBreadcrumb items
        //     this.items.push(...this.extraBreadcrumb);

        //     // Step 8: Always disable the last item
        //     if (this.items.length > 0) {
        //         this.items[this.items.length - 1].disabled = true;
        //     }
        // }

        generateBreadcrumbs() {
            const isDirectURL = !document.referrer;
            const navType = performance.getEntriesByType("navigation")[0].type;
            const isDirectPaste = isDirectURL && navType === "navigate";
            
            if(isDirectPaste){
                sessionStorage.removeItem('para_role_type')
                 sessionStorage.removeItem('para_role');    
            }
            
            const currentPath = this.$route.path;

            this.items = [{ text: "Home", href: "/home", disabled: false }];
            if (currentPath === "/home") return;

            const isMaster = sessionStorage.getItem("is_master_data") === "true";
            const masterModule = sessionStorage.getItem("master_module_name");
            const masterLink = sessionStorage.getItem("master_module_link");

            if (isMaster && masterModule && currentPath !== "/master-data") {
                // Master Data breadcrumb
                this.items.push({
                    text: "Master Data",
                    href: "/master-data",
                    disabled: false
                });

                // Master Module breadcrumb
                const normalizedMasterLink = masterLink.startsWith("/role-dashboard")
                    ? masterLink
                    : `/role-dashboard/${masterLink.replace(/^\/+/, "")}`;

                this.items.push({
                    text: masterModule,
                    to: normalizedMasterLink,
                    disabled: currentPath === normalizedMasterLink // disabled if we are already on the master page
                });

                // Add next breadcrumb ONLY if last item is NOT disabled
                const lastItem = this.items[this.items.length - 1];
                if (!lastItem.disabled) {
                    const pathParts = currentPath.split("/").filter(Boolean);

                    let masterFromUrl = "";
                    if (pathParts[0] === "role-dashboard") {
                        masterFromUrl = pathParts.length >= 3 ? pathParts[1] : pathParts[1];
                    } else {
                        masterFromUrl = pathParts[pathParts.length - 1];
                    }

                    const masterNameFromUrl = masterFromUrl
                        .replace(/-/g, " ")
                        .replace(/\b\w/g, c => c.toUpperCase());

                    if (masterNameFromUrl !== masterModule) {
                        this.items.push({
                            text: masterNameFromUrl,
                            disabled: true
                        });
                    }
                }
            }

            if (isMaster && currentPath === "/master-data") {
                this.items.push({
                    text: "Master Data",
                    disabled: true
                });
                return;
            }

            const para_role = sessionStorage.getItem("para_role");
            const para_role_type = sessionStorage.getItem("para_role_type");
            const search_para_role_type = sessionStorage.getItem("search_para_role_type");
            const dashboardPath = sessionStorage.getItem("emp_role_dashboard_path") || "/role-dashboard";
            const is_quick_link = sessionStorage.getItem("is_quick_link");
            const is_drawer = sessionStorage.getItem("isDrawer") === "true"
            
            if(is_drawer){
                sessionStorage.removeItem("is_quick_link")
            }
            
            const rawLinks = sessionStorage.getItem("sblinks");
            const sblinks = rawLinks ? JSON.parse(rawLinks) : [];

            if (para_role_type) {
            //  sessionStorage.removeItem("para_role"); 
                this.items.push({
                    text: para_role_type ? para_role_type : search_para_role_type,
                    href: dashboardPath,
                    disabled: false
                });
            }

        //student or teacher side para role
            if (
                para_role &&
                !is_drawer &&
                para_role !== "Admin" &&
                !currentPath.endsWith("/emp-role-dashboard")&&
                para_role.toLowerCase() !== "teacher" &&
                // para_role.toLowerCase() !== "class teacher" &&
                para_role.toLowerCase() !== "student" &&
                para_role.toLowerCase() !== "employee" &&
                para_role.toLowerCase() !== "faculty" &&
                para_role.toLowerCase() !== "staff" 
            ) {
                this.items.push({
                    text: para_role,
                    href: "/role-dashboard",
                    disabled: is_quick_link === "true" ? true : false
                });
            }
            
            if (currentPath.endsWith("/emp-role-dashboard") || currentPath.endsWith("/role-dashboard")) {
                const last = this.items[this.items.length - 1];

                if (last && last.text) {
                    last.disabled = true;
                    delete last.href;
                }
            return;
        }

            const match = sblinks.find(item => currentPath.endsWith(item.link));
            if (match) {
                this.items.push({
                    text: match.name,
                    disabled: true
                });
            }

            const is_from_search = sessionStorage.getItem("is_from_search")
            if( !currentPath.startsWith("/emp-role-dashboard") &&!currentPath.startsWith("/role-dashboard")){
                
                    const currentPageName = currentPath
                    .split("/")
                    .filter(Boolean)
                    .pop() 
                    .replace(/-/g, " ")
                    .replace(/\b\w/g, c => c.toUpperCase()); 

                if (!this.items.some(item => item.text === currentPageName)) {
                    this.items.push({
                        text: currentPageName,
                        disabled: true
                    });
                }
        }

        if(currentPath.startsWith("/role-dashboard") && is_from_search){
                
                    const currentPageName = currentPath
                    .split("/")
                    .filter(Boolean)
                    .pop() 
                    .replace(/-/g, " ")
                    .replace(/\b\w/g, c => c.toUpperCase()); 

                if (!this.items.some(item => item.text === currentPageName)) {
                    this.items.push({
                        text: currentPageName,
                        disabled: true
                    });
                }
        }

        // Fallback for direct URL access
        if (this.items.length === 1) {
            const parts = currentPath
                .split("/")
                .filter(Boolean)
                .filter(p => p !== "role-dashboard" && p !== "emp-role-dashboard");

            // Only take the first part, ignore the rest
            const firstPart = parts[0];
            if (firstPart) {
                const text = firstPart
                    .replace(/-/g, " ")
                    .replace(/\b\w/g, c => c.toUpperCase());

                this.items.push({
                    text,
                    disabled: true
                });
            }
        }

        // Always disable only the final breadcrumb
        const last = this.items[this.items.length - 1];
        if (last) {
            last.disabled = true;
            delete last.href;
        }
    },


    },
    watch: {
        "$route.path": {
            immediate: true,
            handler() {
                this.generateBreadcrumbs();
            }
        }
    }
};
</script>
<style scoped>
.breadcrumb-style1 {
    padding: 2px;
    margin-left: 5px;
    margin-top: -22px;
    font-size: medium;
    font-weight: bold;
}

.breadcrumb-style2 {
    padding: 2px;
    font-size: medium;
    font-weight: bold;
    margin-top: -34px;
    margin-left: 5px;
}

@media print {
    .no-display {
        display: none !important;
    }
}
</style>
